import { render, staticRenderFns } from "./swallowOperation.vue?vue&type=template&id=4a7efb82&"
import script from "./swallowOperation.vue?vue&type=script&lang=js&"
export * from "./swallowOperation.vue?vue&type=script&lang=js&"
import style0 from "./swallowOperation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7efb82')) {
      api.createRecord('4a7efb82', component.options)
    } else {
      api.reload('4a7efb82', component.options)
    }
    module.hot.accept("./swallowOperation.vue?vue&type=template&id=4a7efb82&", function () {
      api.rerender('4a7efb82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/swallowOperation.vue"
export default component.exports